export default __webpack_public_path__ + "locales/pt/EmptyTrashDialog.json?hash=01e38e001a6b3401650ab4c0abd8f601";